export const navigationRoute = {
    addCheckAltitude: ['Добавление сверки высотомеров', 'Add check altitude'],
    addComment: ['Добавить комментарий', 'Add comment'],
    addDirection: ['Добавить спрямление', 'Add direction'],
    addHold: ['Добавить зону ожидания', 'Add HOLD'],
    addSpecialPoint: ['Добавление нового ППМ', 'Add special point'],
    addWaypoint: ['Добавить ППМ', 'Add waypoint'],
    aircraftLandImmidient: [
        'Обеспечьте возможность посадки ВС как можно быстрее',
        'You should ensure that the aircraft can land as soon as possible',
    ],
    alternateRoute: ['Альтернативный маршрут', 'Alternate route'],
    alternateRoutes: ['Альтернативные маршруты', 'Alternate routes'],
    beingInHold: ['Нахождение в зоне ожидания', 'Being in the HOLD'],
    cancelDirection: ['Отменить спрямление', 'Cancel Direction'],
    cancelMultiedit: ['Отменить групповое изменение', 'Cancel multiedit'],
    captain: ['КВС', 'Captain'],
    captainAltimeter: ['Высотомер КВС', 'Captain altimeter'],
    changeDirection: ['Изменить спрямление', 'Change direction'],
    checkAltitude: ['Сверка высотомеров', 'Check altitude'],
    checkingAltitude: ['Проверка высотомера', 'Checking altitude'],
    confirmAlternateRoute: [
        'Вы уверены, что хотите выбрать альтернативный маршрут #{{route}}?',
        'Are you sure you want to select an alternate route #{{route}}?',
    ],
    confirmCancelDirectTo: [
        'Вы действительно хотите отменить спрямление из текущего ППМ? Все удалённые ППМ будут восстановлены.',
        'Do you really want to perform cancel operation "Direct to" from the current point? All removed points will be restored.',
    ],
    confirmRemovePoint: ['Вы уверены, что хотите удалить ППМ?', 'Are you sure you want to remove the point?'],
    currentLocation: ['Текущее местоположение', 'Current location'],
    deletePoint: ['Удалить ППМ', 'Delete'],
    differenceBetweenAltimeters: [
        'Разница между показаниями высотомеров составляет более 200 футов. Рекомендуется уйти на высоту < 290 и продолжить маршрут.\n',
        'The difference between the altimeters is more than 200 feets. It is recommended to go to the Fl < 290 and continue the route.\n',
    ],
    direct: ['Спрямление', 'Direct'],
    divert: ['Уход на запасной', 'Divert'],
    divertTo: ['Уход на запасной {{route}}', 'Divert to {{route}}'],
    editCheckAltitude: ['Изменить сверку высотомеров', 'Edit check altitude'],
    editComment: ['Изменить комментарий', 'Edit comment'],
    editDirection: ['Изменить спрямление', 'Edit direction'],
    editHold: ['Изменить зону ожидания', 'Edit HOLD'],
    editPoint: ['Изменить ППМ', 'Edit'],
    editPointRoute: ['Изменить ППМ {{route}} {{rnt}}', 'Edit point {{route}} {{rnt}}'],
    enableLocation: ['Включить геолокацию', 'Enable location'],
    endTime: ['Время окончания', 'End time'],
    firstOfficer: ['Второй пилот', 'First officer'],
    firstOfficerAltimeter: ['Высотомер пилота', 'First Officer'],
    flightLevelNotConsistent: [
        'Эшелон полёта не соответствует показаниям высотомеров',
        'Flight level is not consistent with the values of the altimeters',
    ],
    fullMode: ['Полный режим', 'Full mode'],
    maydayFuel: ['ВНИМАНИЕ, ВНИМАНИЕ, ВНИМАНИЕ, МАЛО ТОПЛИВА!!!', 'MAYDAY, MAYDAY, MAYDAY, FUEL!!!'],
    minimumFuel: ['Минимум Топлива', 'Minimum Fuel'],
    multieditFrom: ['Групповое изменение От', 'Multiedit From'],
    multieditPoint: ['Групповое изменение точек', 'Multiedit point'],
    multieditTo: ['Групповое изменение До', 'Multiedit To'],
    navRoutes: ['План полёта', 'Nav routes'],
    notFindCurrentPos: [
        'Не удалось найти текущее местоположение. Включите определение местоположения или отредактируйте текущий ППМ!',
        'Could not find current position. Turn on the location service or edit the current point!',
    ],
    offset: ['Смещение', 'Offset'],
    protectionFinalFuel: [
        'Пожалуйста, обеспечьте сохранность последнего запаса топлива и безопасное завершение полета',
        'Please ensure the protection of final fuel reserve and safe flight completion',
    ],
    setLocation: ['УСТАНОВИТЬ МЕСТОПОЛОЖЕНИЕ', 'SET LOCATION'],
    setOffset: ['Установка СМЕЩЕНИЯ', 'Set OFFSET'],
    standby: ['Резервный', 'Standby'],
    startTime: ['Время начала', 'Start time'],
    timeCheck: ['Время проверки', 'Time of check'],
};
